<template>
  <div class="polygon">
    <div class="wrapper" :style="{ backgroundColor: color }">
      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: { type: String, default: '#0F3565' },
  },
}
</script>

<style lang="scss" scoped>
@import '@/sass/variables.scss';

.polygon {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #b9ce1e;
    border-radius: 8px;
    transform: rotate(50deg);
    height: 38px;
    width: 38px;
  }

  .content {
    transform: rotate(-50deg);
    margin-bottom: 1px;
    margin-right: 1px;
  }
}
</style>
